
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 20.533c-5.257 0-9.533-4.277-9.533-9.533 0-5.257 4.276-9.533 9.533-9.533 5.256 0 9.533 4.276 9.533 9.533 0 5.256-4.277 9.533-9.533 9.533zm4.06-14.63l-4.032 4.032-3.615-4.032A.733.733 0 007.376 7.94l3.616 4.032-4.087 4.088a.733.733 0 001.037 1.037l4.032-4.032 3.616 4.032a.733.733 0 001.037-1.037l-3.618-4.032 4.088-4.088a.734.734 0 00-1.037-1.037z","fill":"#244C73"}})])
          )
        }
      }
    